import { tokenService } from '@zeus/react-common/lib/business/service/token-service'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from 'src/component/util/spinner'

export const LogoutRedirect = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    setIsLoading(true)
    tokenService.clear().finally(() => {
      setIsLoading(false)
    })
  }, [])
  if (isLoading) return <Spinner />
  return <Navigate to="/login" />
}
